export default __webpack_public_path__ + "static/media/6.c79d56d6.png";